module.exports = __webpack_public_path__ + "static/media/bg-pricing.4d2f2f4b.jpeg";